<div class="main-label">
  Please select your payment method
</div>


@if(!loading()) {
  <div class="form-section">
    <mat-form-field>
      <mat-label>Payment Method</mat-label>
      <mat-select [formControl]="paymentMethod">
        <mat-option value="credit_card">Credit Card</mat-option>
        <mat-option value="paypal_account">Paypal</mat-option>
        @if(donation.type === "ONE_TIME") {
          <mat-option value="us_bank_account">ACH</mat-option>
        }
      </mat-select>
    </mat-form-field>
  
  </div>
  <div class="action-section">
    <button class="btn-success" mat-raised-button [disabled]="!paymentMethod.value" (click)="openPaymentMethodDialog()">Proceed with Donation</button>
  </div>
} @else {
  <div class="form-section">
    <mat-spinner></mat-spinner>
  </div>
}


